import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { UiSvgModule } from "@youm-front/ui-svg";
import Components, { LeftMenuComponent } from "./components";

@NgModule({
  imports: [CommonModule, RouterModule, UiSvgModule],
  declarations: [Components],
  exports: [LeftMenuComponent]
})
export class LeftMenuUiLeftMenuModule {}
